import React from "react";

export const DrawerContext = React.createContext<{
    drawerOpen: boolean;
    setDrawerOpen: React.Dispatch<React.SetStateAction<boolean>>;
}>({ drawerOpen: false, setDrawerOpen: () => null });

